import getRegionalOptions from '../data/store/store';
import { getUserConfiguration } from 'owa-session-store';
var hasLanguageChanged = function () {
    var optionState = getRegionalOptions();
    var SessionSettings = getUserConfiguration().SessionSettings;
    return (optionState.selectedLocale !== null &&
        optionState.selectedLocale !== SessionSettings.UserCulture);
};
export default hasLanguageChanged;
//# sourceMappingURL=hasLanguageChanged.js.map